'use client';

import { WifiOff } from 'lucide-react';

import { Trans } from '@kit/ui/trans';

/**
 * Full-screen overlay shown when the device has no internet connection.
 * Renders on top of existing content so the page behind is preserved.
 */
export function OfflineFallback({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4 px-8 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
          <WifiOff className="h-8 w-8 text-gray-400" />
        </div>

        <h2 className="text-lg font-semibold text-gray-900">
          <Trans
            i18nKey="common:offline.title"
            defaults="No Internet Connection"
          />
        </h2>

        <p className="text-sm text-gray-500">
          <Trans
            i18nKey="common:offline.message"
            defaults="Please check your connection and try again."
          />
        </p>

        <button
          onClick={onRetry}
          className="mt-4 rounded-full bg-gray-900 px-8 py-3 text-sm font-medium text-white transition-colors active:bg-gray-700"
        >
          <Trans i18nKey="common:retry" defaults="Retry" />
        </button>
      </div>
    </div>
  );
}
